import PaymentMethodCategory from '@sunbit-dev/common/enums/cardApply/PaymentMethodCategory';
import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import IPaymentDetailsSubmit from '@sunbit-dev/common/models/cardApply/IPaymentDetailsSubmit';
import PaymentDetails from '@sunbit-dev/ui/src/components/card-apply/pages/paymentDetails/PaymentDetails';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadApplicationDocumentThunk } from '../actions/applicationDocumentsActions';
import { submitExistingPaymentMethodThunk, submitNewPaymentMethodThunk } from '../actions/paymentDetailsActions';
import {
  selectApplicationDocumenRecurringPaymentAuthorization,
  selectExistingPaymentMethods,
  selectLandingDetails,
  selectApplicationDetails,
} from '../selectors';
import { useMixpanel } from '../services/mixpanel/mixPanel';
import { MixpanelCardApplylEvent } from '@sunbit-dev/common/enums/cardApply/MixpanelCardApplylEvent';

const PaymentDetailsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const existingPaymentMethods = useSelector(selectExistingPaymentMethods);
  const landingDetails = useSelector(selectLandingDetails);
  const applicationDetails = useSelector(selectApplicationDetails);
  const { trackForMixPanel } = useMixpanel();

  React.useEffect(() => {
    trackForMixPanel(MixpanelCardApplylEvent.PaymentPage_Views);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    dispatch(loadApplicationDocumentThunk(DocumentTypesTypes.CardApplicationRecurringPaymentAuthorization));
  }, [dispatch]);

  const recurringPaymentsData = useSelector(selectApplicationDocumenRecurringPaymentAuthorization);

  const handleSubmit = React.useCallback(
    (paymentDetailsSubmit: IPaymentDetailsSubmit) => {
      trackForMixPanel(MixpanelCardApplylEvent.PaymentPage_submit);
      switch (paymentDetailsSubmit.paymentMethodCategory) {
        case PaymentMethodCategory.ExistingPaymentMethod:
          dispatch(submitExistingPaymentMethodThunk(paymentDetailsSubmit));
          break;
        case PaymentMethodCategory.Debit:
          dispatch(submitNewPaymentMethodThunk(paymentDetailsSubmit, landingDetails.applicationId || 0));
          break;
        case PaymentMethodCategory.RCC:
          dispatch(submitNewPaymentMethodThunk(paymentDetailsSubmit, landingDetails.applicationId || 0, true));
          break;
        case PaymentMethodCategory.MAIL:
          dispatch(submitNewPaymentMethodThunk(paymentDetailsSubmit, landingDetails.applicationId || 0));
          break;
      }
    },
    [dispatch, landingDetails.applicationId, trackForMixPanel]
  );
  const dueDateChangeMiddleware =
    (onChange: Function) =>
    (dueDate: number): void => {
      trackForMixPanel(MixpanelCardApplylEvent.PaymentPage_Duedate, { dueDate });
      onChange(dueDate);
    };

  return (
    <PaymentDetails
      onDueDateChangeMiddleware={dueDateChangeMiddleware}
      recurringPaymentsData={recurringPaymentsData}
      existingPaymentMethods={existingPaymentMethods.paymentProfiles}
      militaryLendingAct={existingPaymentMethods.isMla}
      submit={handleSubmit}
      referringPartner={landingDetails.referringPartner || ''}
      applicationId={applicationDetails.id!}
    />
  );
};

export default PaymentDetailsContainer;
